import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    width: '100%'
  },
  adminRoot: { opacity: '50%' },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    margin: `${theme.spacing(0.5)}px 0`
  },
  top: { padding: theme.spacing(2) },
  bottom: { padding: theme.spacing(2) },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0
    }
  },
  text: { fontWeight: 500, color: theme.palette.grey[800] }
}))
